import type { SVGProps } from 'react';

/** Figma `fatigue-best.svg` — `tools/make-icon-components.py`가 만든다. 손으로 고치지 않는다. */
export const FatigueBestIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Frame" clipPath="url(#clip0_1320_2654)">
      <path
        id="Vector"
        d="M2 12H6L9 4L13 20L16 8L19 12H24"
        stroke="#FB233B"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1320_2654">
        <rect width="22" height="20" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);
